import { render } from "./KpsCalendarView.vue?vue&type=template&id=510a23ce&scoped=true"
import script from "./KpsCalendarView.vue?vue&type=script&lang=js"
export * from "./KpsCalendarView.vue?vue&type=script&lang=js"

import "./KpsCalendarView.vue?vue&type=style&index=0&id=510a23ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510a23ce"]])

export default __exports__